"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementActionText = exports.moduleBoxStyles = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_redux_1 = require("react-redux");
var react_localize_redux_1 = require("react-localize-redux");
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var UserStore = __importStar(require("../../../app/store/UserStore"));
var apiUrls_1 = __importDefault(require("../../../youwell-common/apiUrls"));
var components_1 = require("../../../youwell-common/components");
var constants_1 = require("../../../common/constants");
var store_1 = require("../../../app/store");
var translate_1 = __importDefault(require("../../../app/localization/translate"));
var youwell_common_1 = require("../../../youwell-common");
var dateUtils_1 = require("../../../youwell-common/dateUtils");
var backgroundColorStop = 180;
var progressSize = 38;
var moduleBoxStyles = function (theme) { return (0, core_1.createStyles)({
    root: {
        borderRadius: theme.youwell.shapes.borderRadius,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        boxShadow: theme.youwell.shadows.default,
        minHeight: 400,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#A6D8DB',
    },
    card: {
        marginTop: 160,
        backgroundColor: theme.palette.common.white,
        width: '90%',
    },
    moduleTitle: {
        margin: theme.spacing(1),
    },
    description: {
        margin: theme.spacing(1),
    },
    actions: {
        flex: '1 1 auto',
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
    startButton: {
        width: '60%',
        margin: theme.spacing(1),
        position: 'relative',
        '&$completed': {
            color: theme.youwell.colors.white,
        },
    },
    completed: {},
    active: {},
    circleProgress: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.youwell.colors.highlight,
        borderRadius: theme.youwell.shapes.borderRadiusRounder,
        position: 'absolute',
        left: -2,
    },
    completeProgress: {
        color: theme.palette.secondary.main,
    },
    checkIcon: {
        color: theme.youwell.colors.white,
        position: 'absolute',
        left: 2,
        zIndex: 1,
    },
    shiftedModuleName: {
        marginLeft: progressSize / 2,
    },
}); };
exports.moduleBoxStyles = moduleBoxStyles;
var useStyles = (0, core_1.makeStyles)(exports.moduleBoxStyles, { name: 'ModuleBoxWithOverlay' });
var getElementActionText = function (el, translate, isCurrent, isActiveProgram) {
    if (!isActiveProgram) {
        return translate('dashboard.open');
    }
    if (el.completed) {
        return translate('dashboard.completed');
    }
    if (el.isNotStarted) {
        return translate('dashboard.moduleOpens', { date: (0, dateUtils_1.datestamp)(el.startTime) });
    }
    if (el.isEnded) {
        return translate('dashboard.moduleEnded');
    }
    if (el.prereqNotCompleted) {
        return translate('dashboard.notAvailableYet');
    }
    return isCurrent ? translate('dashboard.continue') : translate('dashboard.start');
};
exports.getElementActionText = getElementActionText;
var ModuleBoxWithOverlay = function (_a) {
    var _b;
    var element = _a.element, index = _a.index, className = _a.className, isCurrent = _a.isCurrent, programId = _a.programId, to = _a.to;
    var dispatch = (0, react_redux_1.useDispatch)();
    var classes = useStyles();
    var theme = (0, core_1.useTheme)();
    var translate = (0, translate_1.default)();
    var patientId = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.auth.profileData) === null || _a === void 0 ? void 0 : _a.id; });
    var isActiveProgram = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.programStore.currentProgram) === null || _a === void 0 ? void 0 : _a.isActiveProgram; });
    var clickElement = function (label) { return function (e) {
        if (youwell_common_1.Auth.isUserAuthenticated()) {
            if (element.disabled) {
                e.preventDefault();
            }
            else {
                dispatch(UserStore.actionCreators.sendActivity({
                    pid: patientId,
                    ppid: programId,
                    l: label,
                    start: new Date(),
                }));
            }
        }
    }; };
    if (!element || !element.module) {
        return null;
    }
    var isCompletedElement = isActiveProgram && element.completed;
    var isCurrentElement = isActiveProgram && isCurrent;
    var module = element.module;
    var cardColors = [theme.youwell.colors.grayDark, theme.youwell.colors.grayMiddle, theme.youwell.colors.grayLight];
    var bottomColor = theme.youwell.colors.defaultBackground;
    var style = {
        backgroundImage: "linear-gradient(to bottom, ".concat(cardColors[index % cardColors.length], " ").concat(backgroundColorStop, "px, ").concat(bottomColor, " ").concat(backgroundColorStop, "px)"),
    };
    if (module.moduleImageId) {
        style.backgroundImage = "linear-gradient(to bottom, transparent ".concat(backgroundColorStop, "px, ").concat(bottomColor, " ").concat(backgroundColorStop, "px), linear-gradient(to bottom, transparent ").concat(backgroundColorStop, "px, white ").concat(backgroundColorStop, "px), url('").concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.media.file, "/").concat(module.moduleImageId, "')");
    }
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.root, className), style: style },
        React.createElement("div", { className: (0, classnames_1.default)(classes.card) },
            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.moduleTitle }, element.name || (React.createElement(react_localize_redux_1.Translate, { id: "dashboard.module", data: { index: index + 1 } }))),
            React.createElement(components_1.HtmlContent, { html: module.description, className: classes.description })),
        React.createElement("div", { className: classes.actions },
            React.createElement(core_1.Button, { variant: isCurrentElement ? 'contained' : 'outlined', color: "secondary", component: react_router_dom_1.Link, to: to, className: (0, classnames_1.default)(classes.startButton, (_b = {}, _b[classes.completed] = isCompletedElement, _b[classes.active] = isCurrentElement, _b)), size: "small", disabled: element.disabled, "aria-label": element.disabled ? translate('dashboard.unavailableModuleAria') : undefined, onClick: clickElement("".concat(constants_1.activityLabels.dashboard.module, "/").concat(index)) }, translate('dashboard.start')))));
};
ModuleBoxWithOverlay.defaultProps = {
    className: undefined,
    isCurrent: false,
};
exports.default = ModuleBoxWithOverlay;
